import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBarsSortUp = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M27.715 12.286a1.285 1.285 0 0 0 .909-2.195l-7.715-7.714a1.285 1.285 0 0 0-1.818 0l-7.714 7.714a1.285 1.285 0 1 0 1.818 1.818l5.52-5.52v30.325A1.29 1.29 0 0 0 20 38c.707 0 1.286-.575 1.286-1.286V6.39l5.52 5.52c.25.247.579.376.909.376Z" })
});
export default SvgBarsSortUp;
